import { useEffect } from 'react';
import { analytics } from 'external-libs/segment';
import { isPresent } from 'utils/isPresent';

import ProIdentity from 'components/ProIdentity/ProIdentity';

export const useInitAnalytics = (isProFetched: boolean, proData: ProIdentity) => {
  useEffect(() => {
    if (isProFetched && isPresent(proData.id) && isPresent(proData.email)) {
      analytics.identify(proData.id, { email: proData.email });
    }
  }, [isProFetched, proData]);
};
